import { call } from 'redux-saga/effects';

import { isPeerDestroyedError } from 'src/services/rpc/helpers';

import { showErrorToast } from './tools';

export type WatcherWorker<A> = (
  action: A
) => Generator<unknown, unknown, unknown>;

/** Best-effort: a throw from the toast would defeat the guard that called it. */
function* reportQuietly(sagaName: string, error: unknown, title: string) {
  try {
    yield showErrorToast(error, title);
  } catch (toastError) {
    console.error(`${sagaName}: error toast failed`, toastError);
  }
}

export const createKeepWatcherAlive =
  (sagaName: string) =>
  <A>(worker: WatcherWorker<A>, reportAs?: string) =>
    function* guardedWorker(action: A) {
      try {
        yield call(worker, action);
      } catch (error) {
        // The page is leaving and RPC was torn down — nothing failed (D7-7986).
        if (isPeerDestroyedError(error)) return;

        const type = (action as { type?: string })?.type ?? 'unknown';

        console.error(
          `${sagaName}: "${type}" worker failed; watcher kept alive`,
          error
        );

        if (reportAs) {
          yield* reportQuietly(sagaName, error, reportAs);
        }
      }
    };
